import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxDateBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-input-datebox-el',
  templateUrl: './input-datebox-el.component.html',
  styleUrls: ['./input-datebox-el.component.css']
})
export class InputDateboxElComponent implements OnInit {

  @ViewChild('dateBoxDx', {static:true}) dateBoxDx:DxDateBoxComponent;
  
  @ViewChild('inputDate', { static: false }) inputDate: ElementRef<HTMLInputElement>;
  //https://stackblitz.com/edit/angular-dynamic-form-builder?file=app%2Fdynamic-form-builder%2Fdynamic-form-builder.component.ts

  @Input() fileDataInput: any
  
  @Input() dataInput: any;
  @Input() dataValue: any;
  @Input() formGroup
  @Input() isDX: boolean = true
  @Input() tabIndex
  @Input() minValue
  @Output() dateEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() dateEventInitialized: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() dateFocusedEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() dateFocusOutEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  dxOptions
  minDate: any;
  
  constructor() {

    this.focusElement = this.focusElement.bind(this)
  }

  ngAfterViewInit() {


    if (typeof this.inputDate != 'undefined') {
       //this.onInitializzedDataBox(this.inputDate)
    }


  }

  ngOnInit() {
   
    const data = this.fileDataInput
   
    let initValue = null;
    this.dxOptions = data 


    if(this.fileDataInput.defaultValue == 'now'){
      if(!this.dataValue ){
        this.dataValue = new Date()
      }
      //this.dataValue 
    }
      

    if(typeof this.dxOptions.minDate != 'undefined'){

      this.minDate = this.dxOptions.minDate
    }
      
     

  }


  onValueChanged($event){


      if($event.value){
        this.dataValue = $event.value

        let c = this.formGroup.get(this.fileDataInput.dataField)
        c.setValue(this.dataValue)
      
      }



      let previousValue= ''
      if($event.previousValue){
        previousValue = $event.previousValue
      }

      let component = this.dateBoxDx
      if($event.component){
        component =  $event.component
      }


      if(this.dxOptions){

        if(this.dxOptions.dataType.toLowerCase() == 'time'){

          try{

          let timeString = ($event.value as string).split('T')[1];

          switch(this.dxOptions.format.split(':').length){
            //HH:mm
            case 2:{
              this.dataValue = `${timeString.split(':')[0]}:${timeString.split(':')[1]}`;
            }break;

            //HH:mm:ss
            case 3:{
              this.dataValue = `${timeString.split(':')[0]}:${timeString.split(':')[1]}:${timeString.split(':')[2]}`;
            }break;
          }

          }catch(ex){

            console.warn('Orario undefined');

          }  
        }
      
      }



      let dataToSend = {
        value: this.dataValue,
        previousValue: previousValue,
        dataField:this.fileDataInput.dataField,
        campo: this.fileDataInput,
        formData: this.dataInput,
        component: component,
        masterComponent: null,
        name: 'onValueChangedDateTime'
      }


      this.dateEvent.emit(dataToSend);

     /*  if($event.value){
        let c = this.formGroup.get(this.fileDataInput.dataField)
        c.setValue($event.value)
        //console.log(c)
      } */
      
  }

  onInitializzedDataBox (event?){
    
    let initValue
      
    if (this.fileDataInput.defaultValue == 'now') {
      initValue = new Date();
      event.component.value = initValue

    }

    if(!event){
      event = {}
    }

   // this.dateBoxDx =event.component;

    event.nativeElement = this.inputDate;
    event.dxComponent = event.component;
    event.editorComponent = this;
    event.id = this.fileDataInput.dataField
    event.minDate = this.minValue

    this.dateEventInitialized.emit(event);

  }

  public focusElement(){
    if(this.isDX){
      this.dateBoxDx.instance.focus()
    }
  }

  dateFocused(ev){
    console.log('dataFocused')
    this.focusElement()

    this.dateFocusedEvent.emit(ev)
  }
  dateFocusOut(ev){
    this.dateFocusOutEvent.emit(ev)
  }

  
 
}